import typeCheck from 'common/util/typeCheck';

import {
  SR_API_ACTION_HOUSEHOLD_GET_APPLICATION,
} from 'api/actionTypes';

// Loads a full household application by ID.
// NOTE: use "getApplications" to get the renter applications.
export default async function loadHouseholdApplication({ state, apiClient }, { applicationId }) {
  typeCheck('applicationId::PositiveNumber', applicationId);
  return apiClient.postWithState({
    action: SR_API_ACTION_HOUSEHOLD_GET_APPLICATION,
    queryId: String(applicationId),
    state: state,
    payload: {
      applicationId: applicationId,
    },
    onSuccess(householdApplication) {
      state.set(['household', 'applicationsById', householdApplication.id], householdApplication);
    },
  });
}
